module.exports = __webpack_public_path__ + "static/media/Zurich-North-Amercia-Green-Headquarters-768x398.65476130.jpg";